module.exports = __webpack_public_path__ + "media/img/monste-purple-d071159d.png";